export default __webpack_public_path__ + "static/media/airbnb-clone-app.baaae2c5.PNG";